// Nationality translations: code -> { en, it, de, fr }
// The `code` is the ISO 3166-1 alpha-3 code used for exports (never changes)
const NATIONALITY_TRANSLATIONS = {
  AFG: { en: 'Afghanistan', it: 'Afghanistan', de: 'Afghanistan', fr: 'Afghanistan' },
  ALB: { en: 'Albania', it: 'Albania', de: 'Albanien', fr: 'Albanie' },
  DZA: { en: 'Algeria', it: 'Algeria', de: 'Algerien', fr: 'Algérie' },
  AND: { en: 'Andorra', it: 'Andorra', de: 'Andorra', fr: 'Andorre' },
  AGO: { en: 'Angola', it: 'Angola', de: 'Angola', fr: 'Angola' },
  ATG: { en: 'Antigua and Barbuda', it: 'Antigua e Barbuda', de: 'Antigua und Barbuda', fr: 'Antigua-et-Barbuda' },
  ARG: { en: 'Argentina', it: 'Argentina', de: 'Argentinien', fr: 'Argentine' },
  ARM: { en: 'Armenia', it: 'Armenia', de: 'Armenien', fr: 'Arménie' },
  AUS: { en: 'Australia', it: 'Australia', de: 'Australien', fr: 'Australie' },
  AUT: { en: 'Austria', it: 'Austria', de: 'Österreich', fr: 'Autriche' },
  AZE: { en: 'Azerbaijan', it: 'Azerbaigian', de: 'Aserbaidschan', fr: 'Azerbaïdjan' },
  BHS: { en: 'Bahamas', it: 'Bahamas', de: 'Bahamas', fr: 'Bahamas' },
  BHR: { en: 'Bahrain', it: 'Bahrein', de: 'Bahrain', fr: 'Bahreïn' },
  BGD: { en: 'Bangladesh', it: 'Bangladesh', de: 'Bangladesch', fr: 'Bangladesh' },
  BRB: { en: 'Barbados', it: 'Barbados', de: 'Barbados', fr: 'Barbade' },
  BLR: { en: 'Belarus', it: 'Bielorussia', de: 'Belarus', fr: 'Biélorussie' },
  BEL: { en: 'Belgium', it: 'Belgio', de: 'Belgien', fr: 'Belgique' },
  BLZ: { en: 'Belize', it: 'Belize', de: 'Belize', fr: 'Belize' },
  BEN: { en: 'Benin', it: 'Benin', de: 'Benin', fr: 'Bénin' },
  BTN: { en: 'Bhutan', it: 'Bhutan', de: 'Bhutan', fr: 'Bhoutan' },
  BOL: { en: 'Bolivia', it: 'Bolivia', de: 'Bolivien', fr: 'Bolivie' },
  BIH: { en: 'Bosnia and Herzegovina', it: 'Bosnia ed Erzegovina', de: 'Bosnien und Herzegowina', fr: 'Bosnie-Herzégovine' },
  BWA: { en: 'Botswana', it: 'Botswana', de: 'Botswana', fr: 'Botswana' },
  BRA: { en: 'Brazil', it: 'Brasile', de: 'Brasilien', fr: 'Brésil' },
  BRN: { en: 'Brunei', it: 'Brunei', de: 'Brunei', fr: 'Brunei' },
  BGR: { en: 'Bulgaria', it: 'Bulgaria', de: 'Bulgarien', fr: 'Bulgarie' },
  BFA: { en: 'Burkina Faso', it: 'Burkina Faso', de: 'Burkina Faso', fr: 'Burkina Faso' },
  BDI: { en: 'Burundi', it: 'Burundi', de: 'Burundi', fr: 'Burundi' },
  CPV: { en: 'Cabo Verde', it: 'Capo Verde', de: 'Kap Verde', fr: 'Cap-Vert' },
  KHM: { en: 'Cambodia', it: 'Cambogia', de: 'Kambodscha', fr: 'Cambodge' },
  CMR: { en: 'Cameroon', it: 'Camerun', de: 'Kamerun', fr: 'Cameroun' },
  CAN: { en: 'Canada', it: 'Canada', de: 'Kanada', fr: 'Canada' },
  CAF: { en: 'Central African Republic', it: 'Repubblica Centrafricana', de: 'Zentralafrikanische Republik', fr: 'République centrafricaine' },
  TCD: { en: 'Chad', it: 'Ciad', de: 'Tschad', fr: 'Tchad' },
  CHL: { en: 'Chile', it: 'Cile', de: 'Chile', fr: 'Chili' },
  CHN: { en: 'China', it: 'Cina', de: 'China', fr: 'Chine' },
  COL: { en: 'Colombia', it: 'Colombia', de: 'Kolumbien', fr: 'Colombie' },
  COM: { en: 'Comoros', it: 'Comore', de: 'Komoren', fr: 'Comores' },
  COG: { en: 'Congo', it: 'Congo', de: 'Kongo', fr: 'Congo' },
  COD: { en: 'Congo (DRC)', it: 'Congo (RDC)', de: 'Kongo (Dem. Rep.)', fr: 'Congo (RDC)' },
  CRI: { en: 'Costa Rica', it: 'Costa Rica', de: 'Costa Rica', fr: 'Costa Rica' },
  CIV: { en: "Côte d'Ivoire", it: "Costa d'Avorio", de: 'Elfenbeinküste', fr: "Côte d'Ivoire" },
  HRV: { en: 'Croatia', it: 'Croazia', de: 'Kroatien', fr: 'Croatie' },
  CUB: { en: 'Cuba', it: 'Cuba', de: 'Kuba', fr: 'Cuba' },
  CYP: { en: 'Cyprus', it: 'Cipro', de: 'Zypern', fr: 'Chypre' },
  CZE: { en: 'Czech Republic', it: 'Repubblica Ceca', de: 'Tschechien', fr: 'République tchèque' },
  DNK: { en: 'Denmark', it: 'Danimarca', de: 'Dänemark', fr: 'Danemark' },
  DJI: { en: 'Djibouti', it: 'Gibuti', de: 'Dschibuti', fr: 'Djibouti' },
  DMA: { en: 'Dominica', it: 'Dominica', de: 'Dominica', fr: 'Dominique' },
  DOM: { en: 'Dominican Republic', it: 'Repubblica Dominicana', de: 'Dominikanische Republik', fr: 'République dominicaine' },
  ECU: { en: 'Ecuador', it: 'Ecuador', de: 'Ecuador', fr: 'Équateur' },
  EGY: { en: 'Egypt', it: 'Egitto', de: 'Ägypten', fr: 'Égypte' },
  SLV: { en: 'El Salvador', it: 'El Salvador', de: 'El Salvador', fr: 'Salvador' },
  GNQ: { en: 'Equatorial Guinea', it: 'Guinea Equatoriale', de: 'Äquatorialguinea', fr: 'Guinée équatoriale' },
  ERI: { en: 'Eritrea', it: 'Eritrea', de: 'Eritrea', fr: 'Érythrée' },
  EST: { en: 'Estonia', it: 'Estonia', de: 'Estland', fr: 'Estonie' },
  SWZ: { en: 'Eswatini', it: 'Eswatini', de: 'Eswatini', fr: 'Eswatini' },
  ETH: { en: 'Ethiopia', it: 'Etiopia', de: 'Äthiopien', fr: 'Éthiopie' },
  FJI: { en: 'Fiji', it: 'Figi', de: 'Fidschi', fr: 'Fidji' },
  FIN: { en: 'Finland', it: 'Finlandia', de: 'Finnland', fr: 'Finlande' },
  FRA: { en: 'France', it: 'Francia', de: 'Frankreich', fr: 'France' },
  GAB: { en: 'Gabon', it: 'Gabon', de: 'Gabun', fr: 'Gabon' },
  GMB: { en: 'Gambia', it: 'Gambia', de: 'Gambia', fr: 'Gambie' },
  GEO: { en: 'Georgia', it: 'Georgia', de: 'Georgien', fr: 'Géorgie' },
  DEU: { en: 'Germany', it: 'Germania', de: 'Deutschland', fr: 'Allemagne' },
  GHA: { en: 'Ghana', it: 'Ghana', de: 'Ghana', fr: 'Ghana' },
  GRC: { en: 'Greece', it: 'Grecia', de: 'Griechenland', fr: 'Grèce' },
  GRD: { en: 'Grenada', it: 'Grenada', de: 'Grenada', fr: 'Grenade' },
  GTM: { en: 'Guatemala', it: 'Guatemala', de: 'Guatemala', fr: 'Guatemala' },
  GIN: { en: 'Guinea', it: 'Guinea', de: 'Guinea', fr: 'Guinée' },
  GNB: { en: 'Guinea-Bissau', it: 'Guinea-Bissau', de: 'Guinea-Bissau', fr: 'Guinée-Bissau' },
  GUY: { en: 'Guyana', it: 'Guyana', de: 'Guyana', fr: 'Guyana' },
  HTI: { en: 'Haiti', it: 'Haiti', de: 'Haiti', fr: 'Haïti' },
  HND: { en: 'Honduras', it: 'Honduras', de: 'Honduras', fr: 'Honduras' },
  HKG: { en: 'Hong Kong', it: 'Hong Kong', de: 'Hongkong', fr: 'Hong Kong' },
  HUN: { en: 'Hungary', it: 'Ungheria', de: 'Ungarn', fr: 'Hongrie' },
  ISL: { en: 'Iceland', it: 'Islanda', de: 'Island', fr: 'Islande' },
  IND: { en: 'India', it: 'India', de: 'Indien', fr: 'Inde' },
  IDN: { en: 'Indonesia', it: 'Indonesia', de: 'Indonesien', fr: 'Indonésie' },
  IRN: { en: 'Iran', it: 'Iran', de: 'Iran', fr: 'Iran' },
  IRQ: { en: 'Iraq', it: 'Iraq', de: 'Irak', fr: 'Irak' },
  IRL: { en: 'Ireland', it: 'Irlanda', de: 'Irland', fr: 'Irlande' },
  ISR: { en: 'Israel', it: 'Israele', de: 'Israel', fr: 'Israël' },
  ITA: { en: 'Italy', it: 'Italia', de: 'Italien', fr: 'Italie' },
  JAM: { en: 'Jamaica', it: 'Giamaica', de: 'Jamaika', fr: 'Jamaïque' },
  JPN: { en: 'Japan', it: 'Giappone', de: 'Japan', fr: 'Japon' },
  JOR: { en: 'Jordan', it: 'Giordania', de: 'Jordanien', fr: 'Jordanie' },
  KAZ: { en: 'Kazakhstan', it: 'Kazakistan', de: 'Kasachstan', fr: 'Kazakhstan' },
  KEN: { en: 'Kenya', it: 'Kenya', de: 'Kenia', fr: 'Kenya' },
  KIR: { en: 'Kiribati', it: 'Kiribati', de: 'Kiribati', fr: 'Kiribati' },
  PRK: { en: 'Korea (North)', it: 'Corea del Nord', de: 'Nordkorea', fr: 'Corée du Nord' },
  KOR: { en: 'Korea (South)', it: 'Corea del Sud', de: 'Südkorea', fr: 'Corée du Sud' },
  KOS: { en: 'Kosovo', it: 'Kosovo', de: 'Kosovo', fr: 'Kosovo' },
  KWT: { en: 'Kuwait', it: 'Kuwait', de: 'Kuwait', fr: 'Koweït' },
  KGZ: { en: 'Kyrgyzstan', it: 'Kirghizistan', de: 'Kirgisistan', fr: 'Kirghizistan' },
  LAO: { en: 'Laos', it: 'Laos', de: 'Laos', fr: 'Laos' },
  LVA: { en: 'Latvia', it: 'Lettonia', de: 'Lettland', fr: 'Lettonie' },
  LBN: { en: 'Lebanon', it: 'Libano', de: 'Libanon', fr: 'Liban' },
  LSO: { en: 'Lesotho', it: 'Lesotho', de: 'Lesotho', fr: 'Lesotho' },
  LBR: { en: 'Liberia', it: 'Liberia', de: 'Liberia', fr: 'Liberia' },
  LBY: { en: 'Libya', it: 'Libia', de: 'Libyen', fr: 'Libye' },
  LIE: { en: 'Liechtenstein', it: 'Liechtenstein', de: 'Liechtenstein', fr: 'Liechtenstein' },
  LTU: { en: 'Lithuania', it: 'Lituania', de: 'Litauen', fr: 'Lituanie' },
  LUX: { en: 'Luxembourg', it: 'Lussemburgo', de: 'Luxemburg', fr: 'Luxembourg' },
  MAC: { en: 'Macao', it: 'Macao', de: 'Macau', fr: 'Macao' },
  MDG: { en: 'Madagascar', it: 'Madagascar', de: 'Madagaskar', fr: 'Madagascar' },
  MWI: { en: 'Malawi', it: 'Malawi', de: 'Malawi', fr: 'Malawi' },
  MYS: { en: 'Malaysia', it: 'Malesia', de: 'Malaysia', fr: 'Malaisie' },
  MDV: { en: 'Maldives', it: 'Maldive', de: 'Malediven', fr: 'Maldives' },
  MLI: { en: 'Mali', it: 'Mali', de: 'Mali', fr: 'Mali' },
  MLT: { en: 'Malta', it: 'Malta', de: 'Malta', fr: 'Malte' },
  MHL: { en: 'Marshall Islands', it: 'Isole Marshall', de: 'Marshallinseln', fr: 'Îles Marshall' },
  MRT: { en: 'Mauritania', it: 'Mauritania', de: 'Mauretanien', fr: 'Mauritanie' },
  MUS: { en: 'Mauritius', it: 'Mauritius', de: 'Mauritius', fr: 'Maurice' },
  MEX: { en: 'Mexico', it: 'Messico', de: 'Mexiko', fr: 'Mexique' },
  FSM: { en: 'Micronesia', it: 'Micronesia', de: 'Mikronesien', fr: 'Micronésie' },
  MDA: { en: 'Moldova', it: 'Moldavia', de: 'Moldau', fr: 'Moldavie' },
  MCO: { en: 'Monaco', it: 'Monaco', de: 'Monaco', fr: 'Monaco' },
  MNG: { en: 'Mongolia', it: 'Mongolia', de: 'Mongolei', fr: 'Mongolie' },
  MNE: { en: 'Montenegro', it: 'Montenegro', de: 'Montenegro', fr: 'Monténégro' },
  MAR: { en: 'Morocco', it: 'Marocco', de: 'Marokko', fr: 'Maroc' },
  MOZ: { en: 'Mozambique', it: 'Mozambico', de: 'Mosambik', fr: 'Mozambique' },
  MMR: { en: 'Myanmar', it: 'Myanmar', de: 'Myanmar', fr: 'Myanmar' },
  NAM: { en: 'Namibia', it: 'Namibia', de: 'Namibia', fr: 'Namibie' },
  NRU: { en: 'Nauru', it: 'Nauru', de: 'Nauru', fr: 'Nauru' },
  NPL: { en: 'Nepal', it: 'Nepal', de: 'Nepal', fr: 'Népal' },
  NLD: { en: 'Netherlands', it: 'Paesi Bassi', de: 'Niederlande', fr: 'Pays-Bas' },
  NZL: { en: 'New Zealand', it: 'Nuova Zelanda', de: 'Neuseeland', fr: 'Nouvelle-Zélande' },
  NIC: { en: 'Nicaragua', it: 'Nicaragua', de: 'Nicaragua', fr: 'Nicaragua' },
  NER: { en: 'Niger', it: 'Niger', de: 'Niger', fr: 'Niger' },
  NGA: { en: 'Nigeria', it: 'Nigeria', de: 'Nigeria', fr: 'Nigeria' },
  MKD: { en: 'North Macedonia', it: 'Macedonia del Nord', de: 'Nordmazedonien', fr: 'Macédoine du Nord' },
  NOR: { en: 'Norway', it: 'Norvegia', de: 'Norwegen', fr: 'Norvège' },
  OMN: { en: 'Oman', it: 'Oman', de: 'Oman', fr: 'Oman' },
  PAK: { en: 'Pakistan', it: 'Pakistan', de: 'Pakistan', fr: 'Pakistan' },
  PLW: { en: 'Palau', it: 'Palau', de: 'Palau', fr: 'Palaos' },
  PSE: { en: 'Palestine', it: 'Palestina', de: 'Palästina', fr: 'Palestine' },
  PAN: { en: 'Panama', it: 'Panama', de: 'Panama', fr: 'Panama' },
  PNG: { en: 'Papua New Guinea', it: 'Papua Nuova Guinea', de: 'Papua-Neuguinea', fr: 'Papouasie-Nouvelle-Guinée' },
  PRY: { en: 'Paraguay', it: 'Paraguay', de: 'Paraguay', fr: 'Paraguay' },
  PER: { en: 'Peru', it: 'Perù', de: 'Peru', fr: 'Pérou' },
  PHL: { en: 'Philippines', it: 'Filippine', de: 'Philippinen', fr: 'Philippines' },
  POL: { en: 'Poland', it: 'Polonia', de: 'Polen', fr: 'Pologne' },
  PRT: { en: 'Portugal', it: 'Portogallo', de: 'Portugal', fr: 'Portugal' },
  QAT: { en: 'Qatar', it: 'Qatar', de: 'Katar', fr: 'Qatar' },
  ROU: { en: 'Romania', it: 'Romania', de: 'Rumänien', fr: 'Roumanie' },
  RUS: { en: 'Russia', it: 'Russia', de: 'Russland', fr: 'Russie' },
  RWA: { en: 'Rwanda', it: 'Ruanda', de: 'Ruanda', fr: 'Rwanda' },
  KNA: { en: 'Saint Kitts and Nevis', it: 'Saint Kitts e Nevis', de: 'St. Kitts und Nevis', fr: 'Saint-Kitts-et-Nevis' },
  LCA: { en: 'Saint Lucia', it: 'Santa Lucia', de: 'St. Lucia', fr: 'Sainte-Lucie' },
  VCT: { en: 'Saint Vincent', it: 'Saint Vincent', de: 'St. Vincent', fr: 'Saint-Vincent' },
  WSM: { en: 'Samoa', it: 'Samoa', de: 'Samoa', fr: 'Samoa' },
  SMR: { en: 'San Marino', it: 'San Marino', de: 'San Marino', fr: 'Saint-Marin' },
  STP: { en: 'São Tomé and Príncipe', it: 'São Tomé e Príncipe', de: 'São Tomé und Príncipe', fr: 'Sao Tomé-et-Príncipe' },
  SAU: { en: 'Saudi Arabia', it: 'Arabia Saudita', de: 'Saudi-Arabien', fr: 'Arabie saoudite' },
  SEN: { en: 'Senegal', it: 'Senegal', de: 'Senegal', fr: 'Sénégal' },
  SRB: { en: 'Serbia', it: 'Serbia', de: 'Serbien', fr: 'Serbie' },
  SYC: { en: 'Seychelles', it: 'Seychelles', de: 'Seychellen', fr: 'Seychelles' },
  SLE: { en: 'Sierra Leone', it: 'Sierra Leone', de: 'Sierra Leone', fr: 'Sierra Leone' },
  SGP: { en: 'Singapore', it: 'Singapore', de: 'Singapur', fr: 'Singapour' },
  SVK: { en: 'Slovakia', it: 'Slovacchia', de: 'Slowakei', fr: 'Slovaquie' },
  SVN: { en: 'Slovenia', it: 'Slovenia', de: 'Slowenien', fr: 'Slovénie' },
  SLB: { en: 'Solomon Islands', it: 'Isole Salomone', de: 'Salomonen', fr: 'Îles Salomon' },
  SOM: { en: 'Somalia', it: 'Somalia', de: 'Somalia', fr: 'Somalie' },
  ZAF: { en: 'South Africa', it: 'Sudafrica', de: 'Südafrika', fr: 'Afrique du Sud' },
  SSD: { en: 'South Sudan', it: 'Sudan del Sud', de: 'Südsudan', fr: 'Soudan du Sud' },
  ESP: { en: 'Spain', it: 'Spagna', de: 'Spanien', fr: 'Espagne' },
  LKA: { en: 'Sri Lanka', it: 'Sri Lanka', de: 'Sri Lanka', fr: 'Sri Lanka' },
  SDN: { en: 'Sudan', it: 'Sudan', de: 'Sudan', fr: 'Soudan' },
  SUR: { en: 'Suriname', it: 'Suriname', de: 'Suriname', fr: 'Suriname' },
  SWE: { en: 'Sweden', it: 'Svezia', de: 'Schweden', fr: 'Suède' },
  CHE: { en: 'Switzerland', it: 'Svizzera', de: 'Schweiz', fr: 'Suisse' },
  SYR: { en: 'Syria', it: 'Siria', de: 'Syrien', fr: 'Syrie' },
  TWN: { en: 'Taiwan', it: 'Taiwan', de: 'Taiwan', fr: 'Taïwan' },
  TJK: { en: 'Tajikistan', it: 'Tagikistan', de: 'Tadschikistan', fr: 'Tadjikistan' },
  TZA: { en: 'Tanzania', it: 'Tanzania', de: 'Tansania', fr: 'Tanzanie' },
  THA: { en: 'Thailand', it: 'Thailandia', de: 'Thailand', fr: 'Thaïlande' },
  TLS: { en: 'Timor-Leste', it: 'Timor Est', de: 'Osttimor', fr: 'Timor oriental' },
  TGO: { en: 'Togo', it: 'Togo', de: 'Togo', fr: 'Togo' },
  TON: { en: 'Tonga', it: 'Tonga', de: 'Tonga', fr: 'Tonga' },
  TTO: { en: 'Trinidad and Tobago', it: 'Trinidad e Tobago', de: 'Trinidad und Tobago', fr: 'Trinité-et-Tobago' },
  TUN: { en: 'Tunisia', it: 'Tunisia', de: 'Tunesien', fr: 'Tunisie' },
  TUR: { en: 'Turkey', it: 'Turchia', de: 'Türkei', fr: 'Turquie' },
  TKM: { en: 'Turkmenistan', it: 'Turkmenistan', de: 'Turkmenistan', fr: 'Turkménistan' },
  TUV: { en: 'Tuvalu', it: 'Tuvalu', de: 'Tuvalu', fr: 'Tuvalu' },
  UGA: { en: 'Uganda', it: 'Uganda', de: 'Uganda', fr: 'Ouganda' },
  UKR: { en: 'Ukraine', it: 'Ucraina', de: 'Ukraine', fr: 'Ukraine' },
  ARE: { en: 'United Arab Emirates', it: 'Emirati Arabi Uniti', de: 'Vereinigte Arabische Emirate', fr: 'Émirats arabes unis' },
  GBR: { en: 'United Kingdom', it: 'Regno Unito', de: 'Vereinigtes Königreich', fr: 'Royaume-Uni' },
  USA: { en: 'United States', it: 'Stati Uniti', de: 'Vereinigte Staaten', fr: 'États-Unis' },
  URY: { en: 'Uruguay', it: 'Uruguay', de: 'Uruguay', fr: 'Uruguay' },
  UZB: { en: 'Uzbekistan', it: 'Uzbekistan', de: 'Usbekistan', fr: 'Ouzbékistan' },
  VUT: { en: 'Vanuatu', it: 'Vanuatu', de: 'Vanuatu', fr: 'Vanuatu' },
  VAT: { en: 'Vatican City', it: 'Città del Vaticano', de: 'Vatikanstadt', fr: 'Vatican' },
  VEN: { en: 'Venezuela', it: 'Venezuela', de: 'Venezuela', fr: 'Venezuela' },
  VNM: { en: 'Vietnam', it: 'Vietnam', de: 'Vietnam', fr: 'Vietnam' },
  YEM: { en: 'Yemen', it: 'Yemen', de: 'Jemen', fr: 'Yémen' },
  ZMB: { en: 'Zambia', it: 'Zambia', de: 'Sambia', fr: 'Zambie' },
  ZWE: { en: 'Zimbabwe', it: 'Zimbabwe', de: 'Simbabwe', fr: 'Zimbabwe' },
};

// Get all nationality codes
export const NATIONALITY_CODES = Object.keys(NATIONALITY_TRANSLATIONS);

// Get translated nationality name for a given code and language
export function getNationalityName(code, lang = 'en') {
  const entry = NATIONALITY_TRANSLATIONS[code];
  return entry ? (entry[lang] || entry.en) : code;
}

// Get all nationalities as array sorted by translated name
export function getNationalities(lang = 'en') {
  return NATIONALITY_CODES.map(code => ({
    code,
    name: getNationalityName(code, lang),
  })).sort((a, b) => a.name.localeCompare(b.name, lang));
}

export default NATIONALITY_TRANSLATIONS;
